import { ContentType, Result } from '@standardnotes/domain-core';
export class GetVaults {
    constructor(items) {
        this.items = items;
    }
    execute() {
        const vaults = this.items.getItems(ContentType.TYPES.VaultListing).sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
        return Result.ok(vaults);
    }
}
